__turbopack_context__.v({
  "dropdown": "styles-module-scss-module__taQvNa__dropdown",
  "dropdown_is_showing": "styles-module-scss-module__taQvNa__dropdown_is_showing",
  "dropdown_link_is_active": "styles-module-scss-module__taQvNa__dropdown_link_is_active",
  "dropdown_links_heading": "styles-module-scss-module__taQvNa__dropdown_links_heading",
  "dropdown_menu": "styles-module-scss-module__taQvNa__dropdown_menu",
  "dropdown_menu_inner": "styles-module-scss-module__taQvNa__dropdown_menu_inner",
  "horizontal_sections": "styles-module-scss-module__taQvNa__horizontal_sections",
  "my_account_dropdown": "styles-module-scss-module__taQvNa__my_account_dropdown",
  "my_account_dropdown_horizontal": "styles-module-scss-module__taQvNa__my_account_dropdown_horizontal",
});
